import { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function Card({
  title,
  description,
  action,
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200/60',
        className,
      )}
      {...rest}
    >
      {(title || action) && (
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            {title ? (
              <div className="text-base font-semibold text-slate-900">
                {title}
              </div>
            ) : null}
            {description ? (
              <p className="mt-0.5 text-xs text-slate-500">{description}</p>
            ) : null}
          </div>
          {action ? <div>{action}</div> : null}
        </div>
      )}
      {children}
    </div>
  );
}
